import { formatMoneyFull } from "@/lib/money"
import { units } from "@/lib/format"
import type { Supply, SupplierTiers } from "../types"
import Section from "./Section"

function Tiers({ entry }: { entry: SupplierTiers }) {
  return (
    <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-xs text-foreground">
      <span className="font-medium">{entry.supplier ?? "Unnamed supplier"}</span>
      {entry.tiers.map((tier) => (
        <span key={tier.min_qty} className="tabular-nums">
          {units(tier.min_qty)}+ @ {tier.unit_price === null ? "no price" : `${formatMoneyFull(tier.unit_price, tier.currency)} ${tier.currency}`}
        </span>
      ))}
    </div>
  )
}

// Suppliers (lead time, MOQ), and their price tiers when the viewer may see
// them.
export default function SupplySection({ supply }: { supply: Supply }) {
  return (
    <Section title="Supply">
      <div className="flex flex-col">
        <div className="grid grid-cols-3 gap-3 pb-1 text-xs font-medium text-foreground">
          <span>Supplier</span>
          <span className="text-right">Lead time</span>
          <span className="text-right">MOQ</span>
        </div>
        {supply.suppliers.map((s, index) => (
          <div key={s.supplier ?? `none-${index}`} className="grid grid-cols-3 gap-3 py-1 text-sm text-foreground">
            <span className="truncate">{s.supplier ?? "No supplier on record"}</span>
            <span className="text-right tabular-nums">
              {s.lead_time_on_record ? `${s.lead_time_days} days` : `${s.lead_time_days} days (default)`}
            </span>
            <span className="text-right tabular-nums">{s.moq === null ? "—" : units(s.moq)}</span>
          </div>
        ))}
      </div>
      {supply.price_tiers && supply.price_tiers.length > 0 && (
        <div className="flex flex-col gap-1 border-t border-border pt-2">
          <div className="text-xs font-medium text-foreground">Price tiers</div>
          {supply.price_tiers.map((entry, index) => (
            <Tiers key={entry.supplier ?? `none-${index}`} entry={entry} />
          ))}
        </div>
      )}
    </Section>
  )
}
